import React from 'react'
import {Link} from 'react-router-dom'
import AddIcon from '@material-ui/icons/PlaylistAdd'
import {makeStyles} from '@material-ui/core/styles/index'
import {Button, useTranslate} from 'react-admin'

const useStyles = makeStyles(theme => ({
    button: {
        marginTop: '1em'
    }
}));

const AddSkillButton = (props) => {
    const {record} = props
    const translate = useTranslate()
    const classes = useStyles();

    return (
        <Button
            className={classes.button}
            component={Link}
            to={`/skills/create?claimsManager=${record.id}`}
            label={translate('resources.skills.buttons.add')}
            title={translate('resources.skills.buttons.add')}
        >
            <AddIcon/>
        </Button>
    )
}

export default AddSkillButton